var render = function render(){var _vm=this,_c=_vm._self._c;return _c('topbar',{attrs:{"titulo":_vm.$t('ACADEMICO_HOME.FECHAMENTO_CURSO_TURMA'),"subtitulo":_vm.$t('ACADEMICO_HOME.FECHAMENTO_CURSO_TURMA_DESCRICAO'),"breadcrumbs":_vm.breadcrumbs}})
}
var staticRenderFns = []

export { render, staticRenderFns }